import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import contractTemplateService from './contract-template.service';

export interface ContractTemplateState {
    is_filled_in: boolean;
}

const ContractTemplateStore: Module<ContractTemplateState, StoreState> = {
    namespaced: true,
    state: {
        is_filled_in: false,
    },
    getters: {},
    mutations: {},
    actions: {
        async get({ commit }, { company_id }: { company_id: number }) {
            return await contractTemplateService.get({ company_id }).then((response) => {
                return response.data;
            });
        },
    },
};

export default ContractTemplateStore;
